
$(document).ready(function () {
    function addEventListenerStamped(el, eventName, handler) {
        if (el.addEventListener) { el.addEventListener(eventName, handler); }
        else { el.attachEvent('on' + eventName, function () { handler.call(el); }); }
    }

    addEventListenerStamped(document, 'stamped:reviews:loaded', function (e) {
        callTheInit();
    });

    let triedTimes = 1;

    function callTheInit() {
        if(triedTimes > 50 || triedTimes == 0) {
            return;
        }
        setTimeout(function () {
            try {
                initCustomReviewBadge();
            } catch (e) {
                triedTimes++;
                callTheInit();
            }
        }, 50)
    }

    function initCustomReviewBadge() {
        const reviewBadge = document.querySelectorAll('[js-custom-review-badge]');
        reviewBadge.forEach(function (badge) {
            const id = badge.getAttribute('js-custom-review-badge');
            const wrapper = document.querySelector('[js-custom-review-badge-wrapper=' + id + ']');
            const stampedBadge = badge.querySelector('.stamped-badge');
            const count = badge.querySelector('.stamped-badge-caption').dataset.reviews;
            const avg = stampedBadge.getAttribute('data-rating');
            const stars = badge.querySelector('.stamped-starrating');

            const starsElement = document.querySelector('[js-custom-review-badge-stars=' + id + ']');
            const avgElement = document.querySelector('[js-custom-review-badge-avg=' + id + ']');
            const countElement = document.querySelector('[js-custom-review-badge-count=' + id + ']');
            
            starsElement.innerHTML = stars.innerHTML;
            avgElement.innerHTML = avg;
            if (Number(avg) >= 5) {
                avgElement.innerHTML = 5;
            }
            countElement.innerHTML = count;

            wrapper.style.display = 'block';
            badge.style.display = 'none';
        });

        triedTimes = 0;
    }

    function hideAllWrapper() {
        const reviewBadgeWrapper = document.querySelectorAll('[js-custom-review-badge-wrapper]');
        reviewBadgeWrapper.forEach(function (wrapper) {
            wrapper.style.display = 'none';
        });
    }
    
    hideAllWrapper();
})


